import React, { useCallback } from "react";
import ReconStatusDetailLayout from "./ReconStatusDetailLayout";
import List from "../commonComponents/List";

const ReconStatusDetailRepeatable = ({formData={}}) => {
    const renderItem = useCallback((item, key) => 
        <ReconStatusDetailLayout
            formData={item}
            key={key}
        />
    , [])

    const keys = Object.keys(formData)
    return <List renderItem={renderItem} data={formData} keys={keys} />
}
 
export default ReconStatusDetailRepeatable;